import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AiMonitoringGuard {
  constructor(
    private auth: AuthenticationService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.auth.isUserAuthenticated().pipe(
      switchMap(account => {
        if (account?.success !== true) {
          return of(false);
        }

        return this.auth.getPlanFeaturesEnabled().pipe(
          map(plan => {
            const allowed = plan?.has_ai_monitoring_access === true;
            if (!allowed) {
              this.router.navigate(['/dashboard']);
            }
            return allowed;
          }),
          catchError(() => {
            this.router.navigate(['/dashboard']);
            return of(false);
          })
        );
      }),
      catchError(() => of(false))
    );
  }
}
